import React, { Component } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as moment from "moment";
import { isEmpty, size } from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
const { SearchBar, ClearSearchButton } = Search;

import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";

import {
  Badge,
  Col,
  Container,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Row,
  UncontrolledDropdown,
  Modal,
  ModalHeader,
  ModalBody,
  Label,
  Button,
  Card,
  CardBody,
} from "reactstrap";

import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";
import VerifyModal from "components/Common/VerifyModal";
import { map } from "lodash";


import DonationList from "./DonationList";
import { donationTotal, getAllDonations } from "store/actions";

class Donations extends Component {
  constructor(props) {
    super(props);
    this.state = {

      activeTab: "1",
    };

  }

  componentDidMount() {
    const { onGetDonationTotal, donationTotal } = this.props;
    onGetDonationTotal();
    this.setState({ donationTotal });
  }

  componentDidUpdate(prevProps) {
    const { onGetDonations, donations } = this.props;
    if (prevProps.donationTotal !== this.props.donationTotal) {
      console.log("isdie did update");
      this.setState({ donationTotal: this.props.donationTotal });
      onGetDonations();
      this.setState({ donations });
    }
  }


  render() {
   
    const { donations, donationTotal } = this.props;
    console.log("donations", donations);
    return (
      <React.Fragment>
        <div className="page-content">
          <Container fluid>
            <Breadcrumbs title="Dashboard" breadcrumbItem="Donations" />
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody>
                  <h4 className="card-title mb-4">Total Donations</h4>
                  <div className="text-center">
                  <i className="mdi mdi-currency-brl mdi-lg" style={{"font-size":"40px", "color": "#405dbf"}}></i>
                  <h4 className="card-title mb-4" style={{"display":"inline-block","font-size":"40px", "color": "#405dbf"}}>.{" "}</h4>
                    <h6 className="card-title mb-4" style={{"display":"inline-block","font-size":"40px", "color": "#405dbf"}}>{donationTotal}</h6>
                     
                    </div>
                  
                  </CardBody>
                </Card>

                <DonationList
                  donations={donations}
   
                />
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}
Donations.propTypes = {
  isLoading: PropTypes.bool,
  error: PropTypes.string,
  match: PropTypes.object,
  history: PropTypes.object,
  onGetDonations: PropTypes.func,
  onGetDonationTotal: PropTypes.func,
  donations: PropTypes.array,
  donationTotal: PropTypes.number,
};

const mapStateToProps = state => ({
  donations: state.AdminFAReducer.donations,
  donationTotal: state.AdminFAReducer.donationTotal,
});

const mapDispatchToProps = dispatch => ({
  onGetDonations: () => dispatch(getAllDonations()),
  onGetDonationTotal: () => dispatch(donationTotal()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Donations);
